import { component } from 'picoapp'
import Flickity from 'flickity-fade'

class HeroCarousel {
  constructor(node, ctx) {
    // bindings
    this.updateCarousel = this.updateCarousel.bind(this)
    this.onClickPaginationDot = this.onClickPaginationDot.bind(this)

    // selectors
    this._node = node
    this._dots = Array.from(this._node.getElementsByClassName('dot'))
    this._hero_carousel = new Flickity(this._node.querySelector('.hero-carousel'), {
      pageDots: false,
      prevNextButtons: false,
      setGallerySize: false,
      autoPlay: 4000,
      fade: true,
      wrapAround: false,
      draggable: false,
      cellAlign: 'left'
    })

    // events
    this._dots.forEach((dot) => { dot.addEventListener('click', this.onClickPaginationDot, false) })
    this._hero_carousel.on('select', this.updateCarousel)

    // set it
    this.updateCarousel()

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Update. Carousel.
  //
  updateCarousel() {
    this._dots.forEach((dot, index) => {
      dot.classList.remove('selected')
      if (index === this._hero_carousel.selectedIndex) {
        dot.classList.add('selected')
      }
    })
  }

  //
  // Click. Pagination Dot.
  //
  onClickPaginationDot(e) {
    let el = e.currentTarget

    if (el.classList.contains('selected') === true) {
      return false
    }

    this._hero_carousel.select(this._dots.indexOf(el))
  }

  //
  // Unmount.
  //
  unmount() {
    // events
    this._dots.forEach((dot) => { dot.removeEventListener('click', this.onClickPaginationDot, false) })
  }
}

export default component((node, ctx) => new HeroCarousel(node, ctx))
